var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "workspace-shell"
  }, [_c('header', {
    staticClass: "workspace-header"
  }, [_vm._m(0), _c('nav', {
    staticClass: "workspace-history",
    attrs: {
      "aria-label": "História aktívnej záložky"
    }
  }, [_c('button', {
    attrs: {
      "type": "button",
      "aria-label": "Späť",
      "title": "Späť v tejto záložke",
      "disabled": !(_vm.activeTab && _vm.activeTab.canGoBack)
    },
    on: {
      "click": function click($event) {
        return _vm.goHistory(-1);
      }
    }
  }, [_c('app-icon', {
    staticClass: "workspace-history-back",
    attrs: {
      "name": "arrow-right",
      "size": 20
    }
  })], 1), _c('button', {
    attrs: {
      "type": "button",
      "aria-label": "Dopredu",
      "title": "Dopredu v tejto záložke",
      "disabled": !(_vm.activeTab && _vm.activeTab.canGoForward)
    },
    on: {
      "click": function click($event) {
        return _vm.goHistory(1);
      }
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "arrow-right",
      "size": 20
    }
  })], 1)]), _c('div', {
    ref: "tabList",
    staticClass: "workspace-tab-list",
    attrs: {
      "role": "tablist",
      "aria-label": "Pracovné záložky"
    }
  }, _vm._l(_vm.tabs, function (tab) {
    return _c('div', {
      key: tab.id,
      staticClass: "workspace-tab",
      "class": {
        'is-active': tab.id === _vm.activeId
      },
      attrs: {
        "role": "presentation"
      }
    }, [_c('button', {
      staticClass: "workspace-tab-select",
      attrs: {
        "id": "workspace-tab-".concat(tab.id),
        "type": "button",
        "role": "tab",
        "aria-label": tab.label,
        "aria-busy": tab.busy,
        "aria-selected": tab.id === _vm.activeId,
        "aria-controls": "workspace-panel-".concat(tab.id),
        "tabindex": tab.id === _vm.activeId ? 0 : -1,
        "title": tab.busy ? "".concat(tab.label, " \u2014 prebieha spracovanie") : tab.done ? "".concat(tab.label, " \u2014 spracovanie dokon\u010Den\xE9") : tab.label
      },
      on: {
        "click": function click($event) {
          return _vm.selectTab(tab.id);
        },
        "keydown": function keydown($event) {
          return _vm.tabKeydown($event, tab.id);
        }
      }
    }, [tab.busy ? _c('span', {
      staticClass: "workspace-spinner",
      attrs: {
        "aria-label": "Prebieha spracovanie"
      }
    }) : tab.done ? _c('span', {
      staticClass: "workspace-done",
      attrs: {
        "aria-label": "Spracovanie dokončené"
      }
    }) : _c('app-icon', {
      attrs: {
        "name": tab.route ? _vm.tabIcon(tab) : 'plus',
        "size": 16
      }
    }), _c('span', {
      staticClass: "workspace-tab-label"
    }, [_vm._v(_vm._s(tab.label))])], 1), tab.id === _vm.activeId && tab.route ? _c('button', {
      staticClass: "workspace-tab-share",
      attrs: {
        "type": "button",
        "aria-label": "Zdie\u013Ea\u0165 z\xE1lo\u017Eku ".concat(tab.label),
        "title": "Skop\xEDrova\u0165 odkaz: ".concat(tab.label)
      },
      on: {
        "click": function click($event) {
          return _vm.shareTab(tab);
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "link",
        "size": 15
      }
    })], 1) : _vm._e(), _c('button', {
      staticClass: "workspace-tab-close",
      attrs: {
        "type": "button",
        "aria-label": "Zavrie\u0165 z\xE1lo\u017Eku ".concat(tab.label),
        "title": "Zavrie\u0165 ".concat(tab.label)
      },
      on: {
        "click": function click($event) {
          return _vm.requestClose(tab);
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "close",
        "size": 15
      }
    })], 1)]);
  }), 0), _c('button', {
    staticClass: "workspace-add",
    attrs: {
      "type": "button",
      "disabled": _vm.tabs.length >= _vm.maximum,
      "title": _vm.tabs.length >= _vm.maximum ? 'Môžeš mať otvorených najviac 5 záložiek' : 'Nová záložka',
      "aria-label": "Pridať novú záložku"
    },
    on: {
      "click": _vm.addTab
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "plus",
      "size": 22
    }
  })], 1), _c('span', {
    staticClass: "workspace-count",
    attrs: {
      "title": "Otvoren\xE9 z\xE1lo\u017Eky: ".concat(_vm.tabs.length, " z 5")
    }
  }, [_vm._v(_vm._s(_vm.tabs.length) + "/5")]), _c('div', {
    staticClass: "workspace-tools",
    attrs: {
      "aria-label": "Upozornenia a vzhľad"
    }
  }, [_vm.supportsUtilities ? _c('button', {
    staticClass: "workspace-tool",
    "class": {
      'has-unseen-update': _vm.utilities.hasUnseenUpdates
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.utilityTabId,
      "title": _vm.utilities.hasUnseenUpdates ? 'Máte novinku v aplikácii' : 'Novinky v aplikácii a spätná väzba',
      "aria-label": "Otvoriť novinky v aplikácii a spätnú väzbu"
    },
    on: {
      "click": function click($event) {
        return _vm.openUtility('updates');
      }
    }
  }, [_c('app-icon', {
    attrs: {
      "name": _vm.utilities.hasUnseenUpdates ? 'bell' : 'info',
      "size": 21
    }
  }), _vm.utilities.hasUnseenUpdates ? _c('span', {
    staticClass: "workspace-utility-badge",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("1")]) : _vm._e()], 1) : _vm._e(), _vm.supportsUtilities ? _c('button', {
    staticClass: "workspace-tool",
    attrs: {
      "type": "button",
      "disabled": !_vm.utilityTabId || !_vm.utilities.messagesReady,
      "aria-label": _vm.utilities.unseenMessages ? "Spr\xE1vy a upozornenia: ".concat(_vm.utilities.unseenMessages, " nepre\u010D\xEDtan\xFDch") : 'Správy a upozornenia',
      "title": "Správy a upozornenia"
    },
    on: {
      "click": function click($event) {
        return _vm.openUtility('messages');
      }
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "chat",
      "size": 21
    }
  }), _vm.utilities.unseenMessages ? _c('span', {
    staticClass: "workspace-utility-badge",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v(_vm._s(_vm.utilities.unseenMessages > 99 ? '99+' : _vm.utilities.unseenMessages))]) : _vm._e()], 1) : _vm._e(), _c('ThemeToggle', {
    staticClass: "workspace-theme-toggle"
  })], 1)]), _c('main', {
    staticClass: "workspace-panels"
  }, _vm._l(_vm.tabs, function (tab) {
    return _c('section', {
      key: tab.id,
      staticClass: "workspace-panel",
      "class": {
        'is-active': tab.id === _vm.activeId
      },
      attrs: {
        "id": "workspace-panel-".concat(tab.id),
        "role": "tabpanel",
        "aria-labelledby": "workspace-tab-".concat(tab.id),
        "aria-hidden": tab.id !== _vm.activeId,
        "inert": tab.id !== _vm.activeId ? '' : null
      }
    }, [tab.src ? _c('iframe', {
      ref: 'frame-' + tab.id,
      refInFor: true,
      staticClass: "workspace-frame",
      attrs: {
        "src": tab.src,
        "title": tab.label,
        "allow": "clipboard-read; clipboard-write; camera; microphone; fullscreen"
      },
      on: {
        "load": function load($event) {
          return _vm.frameLoaded(tab);
        }
      }
    }) : _c('div', {
      staticClass: "workspace-start"
    }, [_vm._m(1, true), _c('div', {
      staticClass: "workspace-module-grid"
    }, _vm._l(_vm.modules, function (module) {
      return _c('button', {
        key: module.name,
        staticClass: "workspace-module",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function click($event) {
            return _vm.openModule(tab, module);
          }
        }
      }, [_c('app-icon', {
        attrs: {
          "name": module.icon,
          "size": 24
        }
      }), _c('span', [_c('strong', [_vm._v(_vm._s(module.label))]), _c('small', [_vm._v(_vm._s(module.detail))])]), _c('app-icon', {
        attrs: {
          "name": "arrow-right",
          "size": 18
        }
      })], 1);
    }), 0), _c('p', {
      staticClass: "workspace-start-note"
    }, [_vm._v("Najviac 5 záložiek naraz. Prepínanie zachová formuláre aj bežiace úlohy; pred obnovením alebo zatvorením celej aplikácie si zmeny ulož.")])])]);
  }), 0), _vm.shareNotice ? _c('div', {
    staticClass: "workspace-share-notice",
    attrs: {
      "role": "status"
    }
  }, [_vm._v(_vm._s(_vm.shareNotice))]) : _vm._e(), _vm.shareLink ? _c('div', {
    staticClass: "workspace-close-backdrop",
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.closeShare.apply(null, arguments);
      }
    }
  }, [_c('section', {
    staticClass: "workspace-close-dialog",
    attrs: {
      "role": "dialog",
      "aria-modal": "true",
      "aria-labelledby": "workspace-share-title"
    }
  }, [_c('h2', {
    attrs: {
      "id": "workspace-share-title"
    }
  }, [_vm._v("Zdieľať " + _vm._s(_vm.shareLabel))]), _c('p', [_vm._v("Skopíruj odkaz kolegovi. Otvorí sa po prihlásení podľa jeho oprávnení.")]), _c('input', {
    ref: "shareInput",
    staticClass: "workspace-share-input",
    attrs: {
      "aria-label": "Odkaz na záložku",
      "readonly": ""
    },
    domProps: {
      "value": _vm.shareLink
    },
    on: {
      "focus": function focus($event) {
        return $event.target.select();
      }
    }
  }), _c('div', {
    staticClass: "workspace-close-actions"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeShare
    }
  }, [_vm._v("Zavrieť")])])])]) : _vm._e(), _vm.closeDialog ? _c('div', {
    staticClass: "workspace-close-backdrop"
  }, [_c('section', {
    staticClass: "workspace-close-dialog",
    attrs: {
      "role": "dialog",
      "aria-modal": "true",
      "aria-labelledby": "workspace-close-title"
    }
  }, [_c('h2', {
    attrs: {
      "id": "workspace-close-title"
    }
  }, [_vm._v("Zavrieť záložku " + _vm._s(_vm.closingTab && _vm.closingTab.label) + "?")]), _c('p', [_vm._v("Táto záložka môže obsahovať neuložené zmeny. Vráť sa a ulož ich, alebo záložku zavri bez uloženia.")]), _c('p', [_vm._v("Spustené AI spracovanie bude pokračovať.")]), _c('div', {
    staticClass: "workspace-close-actions"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.closeDialog = false;
      }
    }
  }, [_vm._v("Pokračovať v práci")]), _c('button', {
    staticClass: "workspace-close-confirm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.confirmClose
    }
  }, [_vm._v("Zavrieť záložku")])])])]) : _vm._e()]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    staticClass: "workspace-brand"
  }, [_c('img', {
    staticClass: "workspace-brand-light",
    attrs: {
      "src": require("@/images/Bankari-logo-inverted-transparent-extrabold.svg"),
      "alt": "Bankári"
    }
  }), _c('img', {
    staticClass: "workspace-brand-dark",
    attrs: {
      "src": require("@/images/Bankari-logo-transparent-extrabold.svg"),
      "alt": "Bankári"
    }
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "workspace-start-heading"
  }, [_c('span', [_vm._v("PRACOVNÝ PRIESTOR")]), _c('h1', [_vm._v("Čomu sa chceš venovať?")]), _c('p', [_vm._v("Vyber sekciu pre túto záložku. V ostatných záložkách zostane rozpracovaná práca otvorená.")])]);

}]

export { render, staticRenderFns }